/**
 * Extensions ride along with the MIME types on purpose: the macOS open panel filters by UTI, and
 * WebKit's mapping from a bare MIME type is unreliable — without `.png`/`.jpg` it offers every
 * file. Unspaced, since a leading space in a token trips some parsers.
 */
export const DEFAULT_ACCEPTED_FILE_TYPES = 'image/png,image/jpeg,.png,.jpg,.jpeg';

export const MAX_IMAGE_SIZE_MB = 30;

/**
 * Kestrel rejects request bodies over 30,000,000 bytes with a 400 before the upload is ever
 * read (EPD-549), so stop oversized files here instead. The margin leaves room for the
 * multipart framing that rides along with the file.
 */
export const MAX_IMAGE_SIZE_BYTES = 29_900_000;

export const IMAGE_REJECTED_TITLE = 'Image cannot be uploaded';

export const IMAGE_REJECTED_MESSAGE =
  'Images must be no larger than {{maxSizeMb}} MB. Please check your file and try again.';
